// extracted by mini-css-extract-plugin
export var badge = "_hv-2";
export var detailsPanel = "_hv-0";
export var resultRow = "_hv-1";